module.exports = __webpack_public_path__ + "static/media/7.1e0f0beb.jpg";